import type { HelpFile } from '../../types/help'
import { ApprovalPoliciesTestIds } from '../../../testids/ApprovalPoliciesTestIds'

export const approvalPoliciesHelp: HelpFile = {
  docPage: '/docs/governance/policies',
  texts: {
    [ApprovalPoliciesTestIds.approvalPoliciesList]:
      'Übersicht aller Genehmigungsrichtlinien — die Regeln, die festlegen, wer einen Antrag in welcher Reihenfolge genehmigen muss.',
    [ApprovalPoliciesTestIds.btnCreatePolicy]: null,
    [ApprovalPoliciesTestIds.colName]: null,
    [ApprovalPoliciesTestIds.colPolicyType]:
      'Auf welchen Antragstyp die Richtlinie greift: Zugriffsprofil, Rolle, Funktionsgruppe oder Regel.',
    [ApprovalPoliciesTestIds.colPriority]:
      'Bei mehreren passenden Richtlinien gewinnt die mit der höheren Priorität.',
    [ApprovalPoliciesTestIds.colConditions]:
      'Bedingungen, die ein Antrag erfüllen muss, damit die Richtlinie greift.',
    [ApprovalPoliciesTestIds.colSteps]:
      'Genehmigungsschritte dieser Richtlinie — jeder Schritt fügt eine Entscheidungsrunde hinzu.',
    [ApprovalPoliciesTestIds.colStatus]:
      'Inaktive Richtlinien werden bei der Auswertung übersprungen und auf neue Anträge nicht angewendet.',
  },
}
